// extracted by mini-css-extract-plugin
export default {"iframe":"styles_iframe__Fw6yp"};